<div class="table__content">
	@if (loading()) {
		<ctx-table-loader />
	} @else {
		@if (empty()) {
			<ctx-table-placeholder
				[icon]="placeholder().icon"
				[header]="placeholder().header | transloco"
				[content]="placeholder().content | transloco"
			/>
		} @else {
			<div class="table__content-items">
				<ng-content />
			</div>
		}
	}
</div>

<!-- todo think about mobile infinite scroll vs pagination -->
@if (!empty() && pagination()) {
	<footer class="table__footer">
		@if (details(); as details) {
			<p class="m-0 table__footer-of">
				{{ 'pagination.of' | transloco: details }}
			</p>
		}

		<tui-pagination
			[index]="index()"
			[length]="length()"
			[activePadding]="0"
			[sidePadding]="-1"
			(indexChange)="onIndexChange($event)"
		/>

		<div class="table__footer-sizer">
			<tui-textfield
				tuiChevron
				tuiTextfieldSize="s"
				tuiTextfieldAppearance="ghost"
				[tuiTextfieldCleaner]="false"
				[content]="sizeTemplate"
			>
				<input [formControl]="sizeControl" tuiSelect />

				<tui-data-list-wrapper *tuiDropdown [items]="sizes" />

				<ng-template #sizeTemplate let-size>
					{{ 'pagination.per-page' | transloco: { size } }}
				</ng-template>
			</tui-textfield>
		</div>
	</footer>
}
